// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FfkOoY4quIQPn9ztoxLf{box-shadow:inset 0 0 0 1px var(--border-neutral-default);border-radius:6px;flex-wrap:wrap;column-gap:4px;padding:4px 8px;display:flex}.FfkOoY4quIQPn9ztoxLf .PvWG81MTcCkcNwGotpoI{max-width:200px;overflow:hidden}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"chip": `FfkOoY4quIQPn9ztoxLf`,
	"forward": `PvWG81MTcCkcNwGotpoI`
};
export default ___CSS_LOADER_EXPORT___;
